import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AppConfig } from '@tech-utils/app-config.service';
import { takeUntil } from 'rxjs/operators';
import { CompletedataService } from '@tech-services/completedata.service';
import { Subject } from 'rxjs';
import { SafeResourceUrl } from '@angular/platform-browser';
import { OrderSignedInterface } from '@techrules/portallib';

@Component({
  selector: 'tech-sign',
  templateUrl: './sign.component.html',
  styleUrls: ['./sign.component.scss'],
})
export class SignComponent implements OnInit {
  private unsubscribe$ = new Subject();
  @ViewChild('formDigitalSign')
  public formDigitalSign: ElementRef;
  public urlDigitalSign: string = AppConfig.settings.digitalSignUrl;
  public formDigitalSignXml: string;

  constructor(private completedataService: CompletedataService) {}

  ngOnInit() {
    this.completedataService
      .getPortfolioSign(localStorage.getItem('portfolioCodeOnboarding'))
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data: OrderSignedInterface) => {
        if (data.xml) {
          this.formDigitalSignXml = data.xml;
          setTimeout(() => {
            (this.formDigitalSign.nativeElement as HTMLFormElement).submit();
          });
        }
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }
}
